<template>
  <div class="ob_subject_question">
    <!-- 搜索 -->
    <div class="oj_select">
      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form
              :inline="true"
              :model="selectForm"
              class="demo-form-inline"
              @submit.native.prevent            >
              <el-form-item label="">
                <el-input  v-model="selectForm.keyword" clearable @clear="handleClear"
                placeholder="请输入题目id或标题"
                @keyup.enter.native='onSelect'
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSelect">搜索</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
        <el-col :span="10"
          ><div class="grid-content bg-purple">&nbsp;</div></el-col
        >
        <el-col :span="2"
          ><div class="grid-content bg-purple-light">
            <div class="cratebtn">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="createEvents"
                >新增问题</el-button
              >
            </div>
          </div></el-col
        >
      </el-row>
    </div>
    <!-- 表格区域 -->
    <template>
      <el-table
        :data="getTabeData"
        border
        v-loading="loading"
        style="width: 100%"
        max-height="900px"
      >
        <el-table-column
          fixed
          prop="problem_id"
          label="问题编号"
          width="120"
        ></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column
          prop="accepted"
          label="正确数量"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="submit"
          label="提交数量"
          width="100"
        ></el-table-column>
        <el-table-column prop="in_date" label="创建时间"> </el-table-column>
        <el-table-column prop="defunct" label="题目状态">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.defunct == 'N'"
              type="success"
              @click="isDefunct(scope.row.problem_id)"
              >上线中</el-button
            >
            <el-button
              v-if="scope.row.defunct == 'Y'"
              type="warning"
              @click="isDefunct(scope.row.problem_id)"
              >已下线</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="defunct" label="添加测试点">
          <template slot-scope="scope">
            <el-button @click="goTestData(scope.row.problem_id)"
              >添加测试点</el-button
            >
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="220">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="查看"
              placement="top"
            >
              <el-button
                @click="handleLookClick(scope.row.problem_id)"
                type="primary"
                icon="el-icon-view"
                size="small"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
            >
              <el-button
                type="success"
                icon="el-icon-edit"
                size="small"
                @click="handleClick(scope.row.problem_id)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="small"
                @click="handleDeleteClick(scope.row.problem_id)"
              ></el-button>
            </el-tooltip>

            <!-- handleClick事件传入scope.row进行操作时，会影响整个一行数据的变动，留作问题探索(转变策略为，点击编辑请求对应ID的信息) -->
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 分页 -->
    <div class="oj_page">
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="sizePage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="EditorDialogVisible"
      width="70%"
      :lock-scroll="false"
      @closed="closed('editorForm')"
    >
      <el-form
        :label-position="'lift'"
        label-width="120px"
        :model="editorForm"
        ref="editorForm"
        :rules="ruleForm"
        :validate-on-rule-change="false"
      >
        <el-form-item label="问题ID" prop="problem_id">
          <el-input v-model="editorForm.problem_id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="问题标题" prop="title">
          <el-input size="small" v-model="editorForm.title"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item :inline="true" label="时间限制" prop="time_limit">
              <el-input
                style="width: 100px"
                v-model="editorForm.time_limit"
                placeholder="时间"
              ></el-input
              ><span>&nbsp;Sec</span>
            </el-form-item></el-col
          >
          <el-col :span="8"
            ><el-form-item label="内存限制" prop="memory_limit">
              <el-input
                style="width: 100px"
                v-model="editorForm.memory_limit"
                placeholder="内存"
              ></el-input
              ><span>&nbsp;MB</span>
            </el-form-item></el-col
          >
          <el-col :span="8"></el-col>
        </el-row>
        <el-form-item label="题目描述" prop="description">
          <Editor
            v-if="EditorDialogVisible"
            ref="Editor_de"
            :heigth="150"
            :editorID="'Editor_description'"
            :html="editorForm.description"
            @change="theEditorChange($event, editorForm, 'description')"
          ></Editor>
        </el-form-item>
        <el-form-item label="输入" prop="input">
          <Editor
            v-if="EditorDialogVisible"
            ref="Editor_i"
            :heigth="150"
            :editorID="'Editor_input'"
            :html="editorForm.input"
            @change="theEditorChange($event, editorForm, 'input')"
          ></Editor>
        </el-form-item>
        <el-form-item label="输出" prop="output">
          <Editor
            v-if="EditorDialogVisible"
            ref="Editor_o"
            :heigth="150"
            :editorID="'Editor_output'"
            :html="editorForm.output"
            @change="theEditorChange($event, editorForm, 'output')"
          ></Editor>
        </el-form-item>
        <el-form-item label="样例输入1">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="editorForm.sample_input"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="样例输出1">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="editorForm.sample_output"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="样例输入2">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="editorForm.sample_input1"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="样例输出2">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="editorForm.sample_output1"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="样例输入3">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="editorForm.sample_input2"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="样例输出3">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="editorForm.sample_output2"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="提示" prop="hint">
          <Editor
            v-if="EditorDialogVisible"
            ref="Editor_h"
            :heigth="150"
            :editorID="'Editor_hint'"
            :html="editorForm.hint"
            @change="theEditorChange($event, editorForm, 'hint')"
          ></Editor>
        </el-form-item>
        <el-form-item label="特殊裁判">
          <el-radio-group v-model="editorForm.spj">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="难度" prop="c_hard_id">
          <el-select v-model="editorForm.c_hard_id" placeholder="请选择">
            <el-option
              v-for="item in dataPool.hard_data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源" prop="c_source_id">
          <el-select v-model="editorForm.c_source_id" placeholder="请选择">
            <el-option
              v-for="item in dataPool.source_data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="知识点" prop="c_know_ids">
          <el-select
            v-model="editorForm.c_know_ids"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in dataPool.know_data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份" prop="year">
          <el-date-picker v-model="editorForm.year" type="year" placeholder="选择年" format="yyyy" value-format="yyyy">
        </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditorDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editorSubmit('editorForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="lookEventDialogVisible"
      width="60%"
      :lock-scroll="false"
      @closed="closed('lookForm')"
    >
      <el-form
        :label-position="'lift'"
        label-width="120px"
        ref="lookForm"
        :model="lookForm"
      >
        <el-form-item label="题目编号 :">
          <el-tag>{{ lookForm.problem_id }}</el-tag>
        </el-form-item>
        <el-form-item label="题目标题 :">
          <el-tag>{{ lookForm.title }}</el-tag>
        </el-form-item>
        <el-form-item label="题目描述 :">
          <span v-html="lookForm.description">{{ lookForm.description }}</span>
        </el-form-item>
        <el-form-item label="提示 :">
          <span v-html="lookForm.hint">{{ lookForm.hint }}</span>
        </el-form-item>
        <el-form-item label="时间限制 :">
          <el-tag>{{ lookForm.time_limit }} Sec</el-tag>
        </el-form-item>
        <el-form-item label="内存限制 :">
          <el-tag>{{ lookForm.memory_limit }} MB</el-tag>
        </el-form-item>
        <el-form-item label="输入 :">
          <span v-html="lookForm.input">{{ lookForm.input }}</span>
        </el-form-item>
        <el-form-item label="输出 :">
          <span v-html="lookForm.output">{{ lookForm.output }}</span>
        </el-form-item>
        <el-form-item label="样例输入1 :">
          <span>{{ lookForm.sample_input }}</span>
        </el-form-item>
        <el-form-item label="样例输出1 :">
          <span>{{ lookForm.sample_output }}</span>
        </el-form-item>
        <el-form-item label="样例输入2 :">
          <span>{{ lookForm.sample_input1 }}</span>
        </el-form-item>
        <el-form-item label="样例输出2 :">
          <span>{{ lookForm.sample_output1 }}</span>
        </el-form-item>
        <el-form-item label="样例输入3 :">
          <span>{{ lookForm.sample_input2 }}</span>
        </el-form-item>
        <el-form-item label="样例输出3 :">
          <span>{{ lookForm.sample_output2 }}</span>
        </el-form-item>
        <el-form-item label="来源 :">
          <span>{{ lookForm.source_name }}</span>
        </el-form-item>
        <el-form-item label="难度 :">
          <span>{{ lookForm.hard_name }}</span>
        </el-form-item>
        <el-form-item label="知识点 :">
          <span>{{ lookForm.c_know_name }}</span>
        </el-form-item>
        <el-form-item label="旧标签 :">
          <span>{{ lookForm.source }}</span>
        </el-form-item>
        <el-form-item label="题目展示状态 :">
          <el-tag v-if="lookForm.defunct == 'N'">上线中</el-tag>
          <el-tag v-if="lookForm.defunct == 'Y'">已下线</el-tag>
        </el-form-item>
        <el-form-item label="创建时间 :">
          <el-tag>{{ lookForm.in_date }}</el-tag>
        </el-form-item>
        <el-form-item label="年份 :" v-if="lookForm.year">
          <el-tag>{{ lookForm.year }}</el-tag>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookEventDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 新增的弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="createEventDialog"
      @closed="closed('createForm')"
      :lock-scroll="false"
      width="65%"
    >
      <el-form
        :model="newEventForm"
        label-width="110px"
        ref="createForm"
        :rules="ruleForm"
        :validate-on-rule-change="false"
      >
        <el-form-item label="题目标题" prop="title">
          <el-input
            v-model="newEventForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item :inline="true" label="时间限制" prop="time_limit">
              <el-input
                style="width: 100px"
                v-model="newEventForm.time_limit"
                placeholder="时间"
              ></el-input
              ><span>&nbsp;Sec</span>
            </el-form-item></el-col
          >
          <el-col :span="8"
            ><el-form-item label="内存限制" prop="memory_limit">
              <el-input
                style="width: 100px"
                v-model="newEventForm.memory_limit"
                placeholder="内存"
              ></el-input
              ><span>&nbsp;MB</span>
            </el-form-item></el-col
          >
          <el-col :span="8"></el-col>
        </el-row>

        <el-form-item label="题目描述" prop="description">
          <Editor
            v-if="createEventDialog"
            ref="Editor_c_description"
            :heigth="200"
            :editorID="'Editor_c_description'"
            :html="newEventForm.description"
            @change="theEditorChange($event, newEventForm, 'description')"
          ></Editor>
        </el-form-item>
        <el-form-item label="输入" prop="input">
          <Editor
            v-if="createEventDialog"
            ref="Editor_c_input"
            :heigth="200"
            :editorID="'Editor_c_input'"
            :html="newEventForm.input"
            @change="theEditorChange($event, newEventForm, 'input')"
          ></Editor>
        </el-form-item>
        <el-form-item label="输出" prop="output">
          <Editor
            v-if="createEventDialog"
            ref="Editor_c_output"
            :heigth="200"
            :editorID="'Editor_c_output'"
            :html="newEventForm.output"
            @change="theEditorChange($event, newEventForm, 'output')"
          ></Editor>
        </el-form-item>
        <template>
          <Formitem
            v-for="item in formItemArray"
            :key="item.num"
            :inputLable="item.inputname"
            :outputLable="item.outputname"
            @inputValue="
              getFormItemInputValue($event, newEventForm, item.sample_input)
            "
            @outputValue="
              getFormItemOutputValue($event, newEventForm, item.sample_output)
            "
          ></Formitem>
        </template>
        <el-row>
          <el-col :span="21"
            >&nbsp;
            <div class="grid-content bg-purple"></div
          ></el-col>
          <el-col :span="3"
            ><div class="add_btn">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addFormItem"
                :disabled="tag === 3 ? true : false"
                v-show="tag === 3 ? false : true"
                >增加样例</el-button
              >
            </div></el-col
          >
        </el-row>

        <el-form-item label="提示" prop="hint">
          <Editor
            v-if="createEventDialog"
            ref="Editor_c_h"
            :heigth="200"
            :editorID="'Editor_c_hint'"
            :html="newEventForm.hint"
            @change="theEditorChange($event, newEventForm, 'hint')"
          ></Editor>
        </el-form-item>

        <el-form-item label="特殊裁判">
          <el-radio-group v-model="newEventForm.spj">
            <el-radio label="1">是</el-radio>
            <el-radio label="0" chicked>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="难度" prop="c_hard_id">
          <el-select v-model="newEventForm.c_hard_id" placeholder="请选择">
            <el-option
              v-for="item in dataPool.hard_data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源" prop="c_source_id">
          <el-select v-model="newEventForm.c_source_id" placeholder="请选择">
            <el-option
              v-for="item in dataPool.source_data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="知识点" prop="c_know_ids">
          <el-select
            v-model="newEventForm.c_know_ids"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in dataPool.know_data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份" prop="year">
          <el-date-picker v-model="newEventForm.year" type="year" placeholder="选择年" format="yyyy" value-format="yyyy">
        </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createEventDialog = false">取 消</el-button>
        <el-button type="primary" @click="createSubmit('createForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Editor from 'common/wangeditor/Editor';
import Formitem from 'common/formitem/Formitem';
import { pcSubjectRules } from 'untils/form_validation.js';
import {
  initProblemsList,
  initProblemSurce,
  findProblems,
  saveProblems,
  deleteProblems,
  addProblems,
  changeProblemDefunct
} from 'api/post/postApi.js';

export default {
  name: 'oj_subject_question',
  props: {
    dataAPI: {
      type: String,
      default: '/v1/problem/list'
    },
    parasms: {
      type: Object,
      default: function () {
        return {}; // 默认不传递defunct参数
      }
    },
    selectDefunct:{
      type:String,
      default:'N'
    }
  },
  components: {
    Editor,
    Formitem
  },
  data() {
    return {
      loading: true,
      tableData: [],
      dataPool: '', //数据池
      // 分页功能参数
      total: 0,
      sizePage: 20,
      currentPage: 1,
      selectForm: {
        keyword: '',
        defunct:''
      },
      EditorDialogVisible: false,
      lookEventDialogVisible: false,
      createEventDialog: false,
      lookForm: {},
      editorForm: {},
      newEventForm: {
        time_limit: '1',
        memory_limit: '128',
        spj: '0'
      },
      ruleForm: null,
      title: '',
      tag: 1, // 记录添加样例输入的数量 最多三个
      formItemArray: [
        {
          num: 1,
          sample_input: 'sample_input',
          sample_output: 'sample_output',
          inputname: '样例输入1',
          outputname: '样例输出1'
        }
      ]
    };
  },
  created() {
    // 数据初始化editorSubmitparsedValue
    this.initData();
  },
  mounted() {
    this.initDatePool();
  },
  // 计算属性
  computed: {
    // 分页控制
    getTabeData: function () {
      const tableData = this.tableData.slice(
        (this.currentPage - 1) * this.sizePage,
        this.currentPage * this.sizePage
      );
      return tableData;
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      const { data: res } = await initProblemsList(this.dataAPI, this.parasms);
      this.tableData = res.data;
      this.total = res.data.length;
      this.loading = false;
    },
    async initDatePool() {
      const { data: res } = await initProblemSurce();
      this.dataPool = res.data;
      /*
        hard_data:
        know_data:
        source_data:
      */
    },
    // 分页功能实现
    // 每页显示
    handleSizeChange(val) {
      this.sizePage = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 编辑
    async handleClick(qid) {
      this.title = '编辑';
      this.ruleForm = pcSubjectRules;
      const params = { id: qid };
      const { data: res } = await findProblems(params);
      this.editorForm = res.data;
      this.EditorDialogVisible = true;
    },
    // 查看
    async handleLookClick(qid) {
      this.title = '查看';
      const params = { id: qid };
      const { data: res } = await findProblems(params);

      this.lookForm = res.data;
      // 转换数组为字符串 做数据回显
      this.lookForm.c_know_name = this.lookForm.c_know_name.toString();
      this.lookEventDialogVisible = true;
    },
    // 更新
    editorSubmit(formName) {
      if (this.editorForm.c_know_ids !== '') {
        this.editorForm.c_know_ids = this.editorForm.c_know_ids.toString();
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // alert('submit!');
          const { data: res } = await saveProblems(this.editorForm);
          if (res.status !== 0) {
            // elementui组件 消息框
            this.$message.error('更新失败！');
          } else {
            this.$message.success('更新成功！');
            this.initData();
          }
          this.EditorDialogVisible = false;
        } else {
          this.$message.error('表单验证未通过！');
          this.editorForm.c_know_ids=null; // 重置表单
          return false;
        }
      });
    },
    // 公用的dialog清空逻辑
    closed(formName) {
      this.editorForm = {};
      this.lookForm = {};
      this.newEventForm = {
        time_limit: '1',
        memory_limit: '128',
        spj: '0'
      };
      this.fileList = [];
      this.formItemArray = [
        {
          num: 1,
          sample_input: 'sample_input',
          sample_output: 'sample_output',
          inputname: '样例输入1',
          outputname: '样例输出1'
        }
      ];
      this.tag = 1;
      this.resetForm(formName);
    },
    // 删除
    async handleDeleteClick(qid) {
      // 询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该信息, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除！');
      }
      const params = { id: qid };
      const { data: res } = await deleteProblems(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error('删除失败！');
      } else {
        this.$message.success('删除成功！');
      }
      this.initData();
    },
    // 新增按钮
    createEvents() {
      this.title = '新增';
      this.ruleForm = pcSubjectRules;
      this.createEventDialog = true;
    },
    // 提交新增表单
    createSubmit(formName) {
      if (this.newEventForm.c_know_ids !== '') {
        this.newEventForm.c_know_ids = this.newEventForm.c_know_ids.toString();
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await addProblems(this.newEventForm);
          if (res.status !== 0) {
            this.$message.error('新增失败！');
          } else {
            this.$message.success('新增成功！');
            this.initData();
          }
          this.createEventDialog = false;
        } else {
          this.$message.error('表单验证未通过！');
          // 验证未通过，重置表单
          this.newEventForm.c_know_ids=null; // 重置表单
          return false;
        }
      });
    },
    // 清除验证规则
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 搜索实现
    async onSelect() {
      this.selectForm.defunct=this.selectDefunct;
      const { data:res } = await initProblemsList(this.dataAPI,this.selectForm);
      if (res.status !== 0) {
        this.$message.error('查找失败！');
        return;
      }
      this.$message.success('查找成功！');
      this.tableData = res.data;
      this.total = res.data.length;
    },
    handleClear(){
      this.initData();
    },
    /**
     *监听富文本编辑器
     */
    // 富文本编辑器的公用方法
    theEditorChange(html, form, type) {
      form[type] = html;
    },
    // 修改上线状态
    async isDefunct(qid) {
      // 询问用户是否修改状态
      const confirmResult = await this.$confirm(
        '此操作将修改问题上线状态, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消修改！');
      }
      const params = { id: qid };
      const { data: res } = await changeProblemDefunct(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error('修改状态失败！');
      } else {
        this.$message.success('修改状态成功！');
        this.initData();
      }
    },
    // 样例输入共有逻辑
    getFormItemInputValue(value, form, item) {
      form[item] = value;
    },
    getFormItemOutputValue(value, form, item) {
      form[item] = value;
    },
    // 添加样例输入
    addFormItem() {
      var i = this.formItemArray.length + 1;
      let test = {
        num: `${i}`,
        sample_input: `sample_input${i - 1}`,
        sample_output: `sample_output${i - 1}`,
        inputname: `样例输入${i}`,
        outputname: `样例输出${i}`
      };
      this.formItemArray.push(test);
      this.tag++;
    },
    // go测试点
    goTestData(id) {
      this.$router.push({
        path: '/home/oj/subject/question_testdata',
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style scoped>
.oj_page {
  height: 100px;
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
.pc_select {
  width: 100%;
}
.imgs {
  width: 150px;
  height: 100px;
}
.z_img {
  width: 150px;
  height: 200px;
}
.img_show {
  width: 300px;
  height: 200px;
}
.cratebtn {
  float: right;
}
.create_input {
  line-height: 32px;
}
.add_btn {
  margin: 0 0 25px 0;
}
</style>
